<template>
  <div class="page-con">
    <div class="page-con-header clearfix sel-modal-header">
      <Button type="primary" icon="ios-add" v-if="isHavePermission('ship:createShip')" @click="showAddModal">新建船舶信息
      </Button>
      <Button type="primary" icon="ios-add" style="margin-left: 10px" v-if="isHavePermission('ship:importShip')"
              @click="showTempModal">导入船舶信息
      </Button>
      <Button type="primary" icon="ios-add" style="margin-left: 10px" v-if="isHavePermission('ship:download')"
              @click="exportShip">导出
      </Button>
      <Button type="primary" style="margin-left: 10px" v-if="isHavePermission('ship:auth')" @click="setAuth(1)">认证审核
      </Button>
      <Button type="primary" style="margin-left: 10px" v-if="isHavePermission('ship:cancelAuth')" @click="setAuth(2)">
        取消认证
      </Button>
      <Button type="primary" style="margin-left: 10px" v-if="isHavePermission('ship:xcwShipCopy')"
              @click="commitCopy()">
        数据同步
      </Button>
      <!--      <Button type="primary" style="margin-left: 10px" v-if="isHavePermission('ship:xcwShipCopy')"-->
      <!--              @click="commitCopyXcw()">-->
      <!--        所有船舶数据同步-->
      <!--      </Button>-->
      <div class="search-box">
        <vxe-input v-model="shipName" type="search" placeholder="船名" @search-click="search"
                   @keyup.enter.native="search"></vxe-input>
        <vxe-input style="margin-left: 10px;" v-model="mmsi" type="search" placeholder="MMSI" @search-click="search"
                   @keyup.enter.native="search"></vxe-input>
        <Button type="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 5px">
          搜索
        </Button>
        <vxe-button icon="vxe-icon--refresh" @click="reset" style="margin-left: 10px">重置</vxe-button>
        <vxe-button icon="vxe-icon--refresh" @click="refresh" style="margin-left: 10px">刷新</vxe-button>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          show-overflow
          stripe
          align="center"
          border="none"
          :loading="loading"
          :data="tableData"
          :filter-config="{remote: true}"
          @filter-change="filterTypeMethod"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          resizable
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown
                v-if="isHavePermission('ship:updateShip') || isHavePermission('ship:removeShip') || row.authStatus === 0 || row.authStatus === 3"
                trigger="click"
                style="margin-left: 20px;cursor:pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <Button class="button-gengduo" v-if="isHavePermission('ship:auth') && row.authStatus === 0"
                          @click="goAuth(row,1)"
                          style="color: #539FFF">认证审核
                  </Button>
                  <Button class="button-gengduo" v-if="isHavePermission('ship:cancelAuth') && row.authStatus === 3"
                          @click="goAuth(row,2)">
                    取消认证
                  </Button>

                  <Button class="button-gengduo" v-if="isHavePermission('ship:updateShip') && row.authStatus !== 3"
                          @click="openUpdateView(row)">编辑
                  </Button>
                  <Button class="button-gengduo" v-if="isHavePermission('ship:removeShip') && row.authStatus !== 3"
                          @click="commitDelete(row.id)" style="color: #ed4014;">删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="shipName" title="船名" width="100" show-overflow>
          <template slot-scope="{ row }">
            <div style="display: flex;align-items: center;justify-content: center">
              <span v-if="isHavePermission('ship:queryShip')" @click="showDetail(row)"
                    style="color: #2D8CF0;cursor:pointer">{{ row.shipName }}</span>
              <span v-if="!isHavePermission('ship:queryShip')">{{ row.shipName }}</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column title="定位" width="80">
          <template slot-scope="{ row }">
            <Button class="navigate" custom-icon="iconfont icon-dingwei" @click="seeMap(row)"></Button>
          </template>
        </vxe-table-column>
        <vxe-table-column field="mmsi" title="MMSI" width="120" show-overflow></vxe-table-column>
        <vxe-table-column field="deadweight" title="载重吨" width="100" show-overflow></vxe-table-column>
        <vxe-table-column field="homePortText" title="船籍港" width="100" show-overflow></vxe-table-column>
        <vxe-table-column field="shipType" title="船舶种类" width="100" show-overflow></vxe-table-column>
        <vxe-table-column field="shipLength" title="船长(m)" width="80" show-overflow></vxe-table-column>
        <vxe-table-column field="shipWidth" title="船宽(m)" width="80" show-overflow></vxe-table-column>
        <vxe-table-column field="totalweight" title="总吨" width="80" show-overflow></vxe-table-column>
        <vxe-table-column field="netweight" title="净吨" width="80" show-overflow></vxe-table-column>
        <vxe-table-column field="loadDraught" title="满载吃水(m)" width="100" show-overflow></vxe-table-column>
        <vxe-table-column field="depth" title="型深" width="60" show-overflow></vxe-table-column>
        <vxe-table-column field="buildTime" title="建造时间" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.buildTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="authStatus" title="认证状态" width="120"
                          :filters="[{label: '已认证', value: 3}, {label: '未认证', value: 0}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span style="color: #F59A23">{{ row.authStatus | authStatus }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isXcwCopy" title="同步状态" min-width="100"
                          :filters="[{label: '是', value: 1}, {label: '否', value: 0}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span>{{ row.isXcwCopy === 1 ? '是' : '否' }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" min-width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" min-width="120"
                          v-if="isHavePermission('global:viewCreateTime')"
                          :filters="[{label: '升序', value: 0}, {label: '倒序', value: 1}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="createVisible" :title="title" width="1400" height="900" @close="closeCreate" resize
               position="center"
               destroy-on-close>
      <create-ship-modal @afterSave="closeCreateModal" @close="createVisible = false"
                         ref="modalCreate"></create-ship-modal>
    </vxe-modal>
    <vxe-modal v-model="importVisible" title="导入船舶信息" width="1200" height="600" @close="closeImport" resize
               position="center">
      <import-ship @afterSave="closeImportModal" ref="modalImport"></import-ship>
    </vxe-modal>
    <vxe-modal v-model="templateVisible" title="船舶信息导入" width="1000" height="620" @close="closeTemplate"
               position="center">
      <import @goImport="goImport" @close="closeTemplate" ref="modalTemplate"></import>
    </vxe-modal>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" position="center">
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
import CreateShipModal from "./CreateShipModal";
import ImportShip from "./ImportShip";
import $api from '@/apiProvider';
import Import from "@/components/common/Import"; // 导入
import getAuthOrization from "@/mixin/getAuthOrization";
import {hideLoading, isEmpty, postBlob, saveBlob, showLoading} from "@/utils/util";
import Message from "@/components/common/Message";

export default {
  components: {CreateShipModal, ImportShip, Import, Message},
  mixins: [getAuthOrization],
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100
      },
      shipNum: null,
      mmsi: null,
      shipName: null,
      tableData: [],
      isDesc: null,
      orderBy: null,
      title: '',
      loading: false,
      createVisible: false,
      importVisible: false,
      templateVisible: false,
      records: [],
      authStatus: null,
      messageVisible: false,
      message: '',
      isXcwCopy: null
    }
  },
  filters: {
    authStatus(val) {
      if (val != null) {
        if (val === 0) {
          return "未认证"
        }
        if (val === 1) {
          return "待审核"
        }
        if (val === 2) {
          return "未通过"
        }
        if (val === 3) {
          return "已认证"
        }
        if (val === 4) {
          return "已过期"
        }
      }
    }
  },
  mounted() {
    this.$bus.$on("船舶信息", () => {
      this.reset();
      this.search();
    });
    this.getHomePort();
  },
  methods: {
    closeMessage() {
      this.messageVisible = false;
    },
    async goAuth(row, status) {
      showLoading();
      let res = await $api.carShip.request('authShipByPlat', {
        ids: [row.id],
        status: status
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success(status === 1 ? '认证成功' : '取消成功');
        this.queryShipList();
      } else {
        let data = res.data;
        let message = '';
        if (data.length > 0) {
          data.map(i => {
            message = message + i.failMsg + '\n';
          })
        }
        if (message === '') {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        } else {
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    },
    async setAuth(status) {
      let records = this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: '请选择至少一条船舶信息',
          status: "error",
        });
        return
      }
      let idList = [];
      records.map(i => {
        idList.push(i.id);
      })
      showLoading();
      let res = await $api.carShip.request('authShipByPlat', {
        ids: idList,
        status: status
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success(status === 1 ? '认证成功' : '取消成功');
        this.records = [];
        this.queryShipList();
      } else {
        let data = res.data;
        let message = '';
        if (data.length > 0) {
          data.map(i => {
            message = message + i.failMsg + '\n';
          })
        }
        if (message === '') {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        } else {
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    },
    selectChangeEvent({checked, row}) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({checked, records}) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    async getHomePort() {
      let res = await $api.xcwDict.request('queryProCityAreaList');
      if (res.code === 1) {
        this.homePort = res.data;
        this.getDict();
      } else {
        this.$XModal.message(res.message);
      }
    },
    async getDict() {
      let res = await $api.dict.get("searchDic");
      if (res.status === 1) {
        this.dict = res.data;
        this.queryShipList();
      } else {
        this.$XModal.message(res.message);
      }
    },
    seeMap(row) {
      let mmsi = row.mmsi ? row.mmsi : row.shipName;
      window.open(`/carShip/fwShipFrame/${mmsi}`);
    },
    reset() {
      this.shipName = null;
      this.mmsi = null;
    },
    filterTypeMethod({column, property, values, datas, filters, $event}) {
      this.page.currentPage = 1;
      if (property === "createTime") {
        if (values.length > 0) {
          this.isDesc = values[0];
          this.orderBy = 7;
        } else {
          this.isDesc = null;
          this.orderBy = null;
        }
      } else if (property === "authStatus") {
        if (values.length > 0) {
          this.authStatus = values[0];
        } else {
          this.authStatus = null;
        }
      } else if (property === 'isXcwCopy') {
        if (values.length > 0) {
          this.isXcwCopy = values[0];
        } else {
          this.isXcwCopy = null;
        }
      }
      this.queryShipList();
    },
    showTempModal() {
      this.$refs.modalTemplate.setExport('0524船舶信息导入模板.xls');
      this.templateVisible = true;
    },
    goImport() {
      this.templateVisible = false;
      this.importVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    async exportShip() {
      if (isEmpty(this.tableData)) {
        this.$XModal.message("暂无数据");
        return;
      }
      showLoading();
      let res = postBlob("/api/order/carship/exportShip", this.paramsObj);
      hideLoading();
      await saveBlob("导出船舶.xls", res.data);
    },
    refresh() {
      this.queryShipList();
    },
    async queryShipList() {
      this.loading = true;
      this.paramsObj = {
        shipName: this.shipName,
        mmsi: this.mmsi,
        orderBy: this.orderBy,
        isDesc: this.isDesc,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        sourceType: 1,
        authStatus: this.authStatus,
        isXcwCopy: this.isXcwCopy
      }
      let res = await $api.carShip.request('queryShipList', this.paramsObj);
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        let data = res.data.rows;
        let homePort = this.homePort;
        let dict = this.dict;
        data.map(i => {
          if (i.homePort) {
            let homePortList = i.homePort.split(',');
            i.homePort = homePortList;
            let homePortText = '';
            if (homePortList[homePortList.length - 1].length === 5) {
              dict.map(j => {
                if (parseInt(homePortList[1]) === j.dictCode && parseInt(homePortList[0]) === j.dictCodeP) {
                  homePortText = j.dictText
                }
              })
            } else {
              homePort.map(j => {
                if (homePortList[homePortList.length - 1] === j.cityCode) {
                  homePortText = j.cityText;
                }
              })
            }
            i.homePortText = homePortText;
          }
        })
        this.tableData = data;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    search() {
      this.page.currentPage = 1
      this.queryShipList();
    },
    closeCreateModal() {
      this.queryShipList();
      this.createVisible = false;
    },
    closeImportModal() {
      this.queryShipList();
      this.importVisible = false;
    },
    closeCreate() {
      this.$refs.modalCreate.reset();
    },
    closeImport() {
      this.$refs.modalImport.close();
    },
    changePage(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.queryShipList();
    },
    showAddModal() {
      this.title = '新增船舶信息'
      this.createVisible = true;
      this.$nextTick(() => {
        this.$refs.modalCreate.showUpdate();
      })
    },
    showDetail(row) {
      this.title = '查看船舶信息'
      this.createVisible = true;
      this.$nextTick(() => {
        this.$refs.modalCreate.setUpdate(row);
        this.$refs.modalCreate.setReadOnly();
      })
    },
    openUpdateView(row) {
      this.title = '编辑船舶信息'
      this.createVisible = true;
      this.$nextTick(() => {
        this.$refs.modalCreate.setUpdate(row);
      })
    },
    commitDelete(id) {
      this.$XModal.confirm('您确定要删除吗？').then(type => {
        if (type === 'confirm') {
          this.deleteShip(id);
        }
      })
    },
    commitCopyXcw() {
      this.$XModal.confirm('您确定要同步数据吗？').then(type => {
        if (type === 'confirm') {
          this.goCopyXcw();
        }
      })
    },
    async goCopyXcw() {
      showLoading();
      let res = await $api.carShip.request('copyXcwShip');
      if (res.status === 1) {
        hideLoading();
        this.$Message.success('同步成功');
      } else {
        hideLoading();
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },

    async commitCopy() {
      let records = this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: '请选择至少一条船舶信息',
          status: "error",
        });
        return
      }
      let idList = [];
      let noteList = [];
      records.map(i => {
        idList.push(i.id);
        if (i.authStatus != 3) {
          noteList.push(i.shipName);
        }
      })
      if (noteList.length > 0) {
        this.$XModal.alert({
          message: noteList + "未认证无法同步",
          status: "error",
        });
        return
      }
      showLoading();
      let res = await $api.carShip.request('batchCopyXcwShip', {
        idList: idList
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('同步成功');
        this.records = [];
        this.queryShipList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },

    async deleteShip(id) {
      let res = await $api.carShip.request('removeShip', {id: id});
      if (res.status === 1) {
        this.$Message.success('删除成功');
        this.queryShipList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  }
}
</script>

<style>
@import "../../../src/assets/icon/icon-navigate/iconfont.css";

.modal-container {
  position: relative;
  height: 100%
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.navigate, .navigate:active, .navigate:focus, .navigate:hover {
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
}
</style>
